import { defineStore } from 'pinia'
import $api from '@/api/index'

interface DictItem {
  name: string
  value: string
  [key: string]: any
}

interface DictState {
  computerTypes: DictItem[]
  computerFaults: DictItem[]
  // 可以继续添加其他字典类型
}

export const useDictStore = defineStore('dict', {
  state: (): DictState => ({
    computerTypes: uni.getStorageSync('dict_computer_types') || [],
    computerFaults: uni.getStorageSync('dict_computer_faults') || []
  }),

  getters: {
    // 根据 value 获取电脑类型名称
    getComputerTypeName: (state) => {
      return (value: string): string => {
        const item = state.computerTypes.find((t) => t.value === value)
        return item?.name || ''
      }
    },

    // 根据 value 获取电脑故障名称
    getComputerFaultName: (state) => {
      return (value: string): string => {
        const item = state.computerFaults.find((f) => f.value === value)
        return item?.name || ''
      }
    }
  },

  actions: {
    /**
     * 获取电脑类型字典
     * @param force 是否强制刷新
     */
    async fetchComputerTypes(force = false) {
      // 如果已有数据且不强制刷新，直接返回
      if (this.computerTypes.length > 0 && !force) {
        return this.computerTypes
      }

      try {
        const res = await $api.common.dictValue({ dict_code: 'computer_type' })
        if (res.code === '000000') {
          this.computerTypes = res.data?.value || []
          // 持久化存储
          uni.setStorageSync('dict_computer_types', this.computerTypes)
        }
        return this.computerTypes
      } catch (error) {
        console.error('获取电脑类型字典失败:', error)
        return this.computerTypes
      }
    },

    /**
     * 获取电脑故障字典
     * @param force 是否强制刷新
     */
    async fetchComputerFaults(force = false) {
      // 如果已有数据且不强制刷新，直接返回
      if (this.computerFaults.length > 0 && !force) {
        return this.computerFaults
      }

      try {
        const res = await $api.common.dictValue({ dict_code: 'computer_fault' })
        if (res.code === '000000') {
          this.computerFaults = res.data?.value || []
          // 持久化存储
          uni.setStorageSync('dict_computer_faults', this.computerFaults)
        }
        return this.computerFaults
      } catch (error) {
        console.error('获取电脑故障字典失败:', error)
        return this.computerFaults
      }
    },

    /**
     * 初始化所有字典数据
     */
    async initAllDicts() {
      await Promise.all([this.fetchComputerTypes(), this.fetchComputerFaults()])
    },

    /**
     * 清除所有字典缓存
     */
    clearAllDicts() {
      this.computerTypes = []
      this.computerFaults = []
      uni.removeStorageSync('dict_computer_types')
      uni.removeStorageSync('dict_computer_faults')
    },

    /**
     * 刷新所有字典数据
     */
    async refreshAllDicts() {
      await Promise.all([this.fetchComputerTypes(true), this.fetchComputerFaults(true)])
    }
  }
})